import { useState } from 'react';
import { toast } from '../../components/global';

const useCopyToClipboard = () => {
  const [copiedText, setCopiedText] = useState(null);

  const copy = async (text) => {
    if (!navigator?.clipboard) {
      toast.warning('Clipboard not supported');
      return false;
    }

    // Try to save to clipboard then save it in the state if worked
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      return true;
    } catch (error) {
      toast.error('Copy failed', error);
      setCopiedText(null);
      return false;
    }
  };

  return {
    copy,
    copiedText
  };
};
export default useCopyToClipboard;
